import React from 'react'
import { Button, ListGroup, Modal, OverlayTrigger, Popover } from 'react-bootstrap'
import UserInfo from '../../../../interfaces/UserInfo';
import { useAuth } from '../../../../firebase/AuthProvider';
import AvatarImage from '../../../ui/Avatar/AvatarImage';
import { useNavigate } from 'react-router-dom';
import { createConversation } from '../../../../services/chatService/ChatService';
import { toast } from 'react-toastify';
import './ChatParticipantModal.css';
import { IoCloseOutline } from "react-icons/io5";
import { FiSearch } from "react-icons/fi";

interface ChatParticipantModalProps {
    showUsersModal: boolean;
    handleCloseUsersModal: () => void;
    participants: UserInfo[];
}

const IoClose = IoCloseOutline as any;
const Search = FiSearch as any;

const ChatParticipantModal: React.FC<ChatParticipantModalProps> = ({
    handleCloseUsersModal,
    showUsersModal,
    participants
}) => {
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = React.useState("");

    const filteredParticipants = participants.filter((user) => {
        const search = searchTerm.toLowerCase();

        return (
            user.firstName?.toLowerCase().includes(search) ||
            user.lastName?.toLowerCase().includes(search) ||
            user.displayName?.toLowerCase().includes(search) ||
            user.email?.toLowerCase().includes(search)
        );
    });

    const handleDirectMessage = async (targetUserId: string) => {
        if (!currentUser) {
            toast.error("You must be logged in to start a conversation.");
            return;
        }

        const token = await currentUser.getIdToken();
        if (!token) {
            toast.error("Authentication token not found.");
            return;
        }

        try {
            const res = await createConversation(token, [targetUserId]);
            if (res.success) {
                handleCloseUsersModal();
                navigate(`/chat/${res.data.id}`);
            } else {
                if (res.data?.id) {
                    handleCloseUsersModal();
                    navigate(`/chat/${res.data.id}`);
                } else {
                    toast.error(res.message || "Failed to start conversation.");
                }
            }
        } catch (error: any) {
            toast.error(error.message || "An error occurred while starting the conversation.");
        }
    };

    const handleViewProfile = () => {
        // TODO: Implement profile view navigation
    };

    return (
        <>
            {/* <Modal show={showUsersModal} onHide={handleCloseUsersModal} className='custom_popup' centered dialogClassName="chat-participant-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Participants List</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    <ListGroup variant='flush'>
                        {participants?.map((user, index) => {
                            const isCurrentUser = user.id === currentUser?.uid;

                            const popover = (
                                <Popover id={`popover-${user.id}`}>
                                    <Popover.Body className="p-0">
                                        <ListGroup variant="flush">
                                            <ListGroup.Item action onClick={handleViewProfile}>
                                                View Profile
                                            </ListGroup.Item>
                                            <ListGroup.Item action onClick={() => handleDirectMessage(user.id)}>
                                                Message
                                            </ListGroup.Item>
                                        </ListGroup>
                                    </Popover.Body>
                                </Popover>
                            );

                            const nameElement = (
                                <div className="fw-bold">
                                    {user.firstName} {user.lastName} {isCurrentUser && "(You)"}
                                </div>
                            );

                            return (
                                <OverlayTrigger trigger={['click']} placement="right" overlay={popover} rootClose>
                                    <ListGroup.Item key={index} className="chat-participant-item d-flex align-items-center">
                                        <AvatarImage userId={user.id} size='sm' />
                                        <div className="ms-3 my-2">
                                            <div className="fw-bold">
                                                {user.firstName} {user.lastName} {isCurrentUser && "(You)"}
                                            </div>
                                            <div className='text-muted'>
                                                {user.email}
                                            </div>
                                           
                                        </div>
                                    </ListGroup.Item>
                                </OverlayTrigger>
                            )
                        })}
                    </ListGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseUsersModal}>Close</Button>
                </Modal.Footer>
            </Modal> */}

            {
                showUsersModal &&
                <div className="fixed inset-0 z-[1050] flex items-center justify-center bg-black/40">
                    <div className="w-[448px] rounded-xl bg-white shadow-xl px-6 pt-8 pb-3 mx-[20px]">
                        <div className="flex items-center justify-between relative">
                            <h2 className="text-[22px] font-bold">Group Members</h2>
                            <button onClick={handleCloseUsersModal} className="absolute -top-1.5 -right-1.5">
                                <IoClose className="text-[24px] text-[#0A0A0A]" />{""}
                            </button>
                        </div>
                        <>
                            <div className="flex items-center bg-[#F9FAFB] rounded-[10px] px-[12px] mt-[15px]" style={{ border: "1px #E5E7EB solid" }}>
                                <Search className=" text-[#99A1AF] " />
                                <input
                                    placeholder="Search by name or email"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    style={{
                                        width: "100%",
                                        border: "none",
                                        background: "transparent",
                                        outline: "none",
                                        boxShadow: "none",
                                        color: "#0A0A0A80",
                                        fontWeight: "400",
                                    }}
                                />
                            </div>

                            <div className="max-h-[315px] overflow-y-auto mt-3 no-scrollbar">
                                {filteredParticipants.length === 0 ? (
                                    <p className="text-center text-[#6A7282] py-10 text-sm">
                                        No participants found!
                                    </p>
                                ) : (
                                    filteredParticipants.map((user) => {
                                        const name =
                                            user.displayName || `${user.firstName} ${user.lastName}`;
                                        const isCurrentUser = user.id === currentUser?.uid;

                                        const popover = (
                                            <Popover id={`popover-${user.id}`}>
                                                <Popover.Body className="p-0">
                                                    <ListGroup variant="flush">
                                                        <ListGroup.Item action onClick={handleViewProfile}>
                                                            View Profile
                                                        </ListGroup.Item>
                                                        <ListGroup.Item
                                                            action
                                                            onClick={() => handleDirectMessage(user.id)}
                                                        >
                                                            Message
                                                        </ListGroup.Item>
                                                    </ListGroup>
                                                </Popover.Body>
                                            </Popover>
                                        );

                                        return (
                                            <OverlayTrigger
                                                key={user.id}
                                                trigger="click"
                                                placement="right"
                                                overlay={popover}
                                                rootClose
                                            >
                                                <div className="flex items-center gap-3 p-3 rounded-[10px] hover:bg-[#F9F6FF] cursor-pointer">
                                                    {/* Avatar */}
                                                    <div
                                                        className="w-14 h-14 rounded-full flex items-center justify-center flex-shrink-0"
                                                        style={{
                                                            border:
                                                                user.employeeRole === "Participant"
                                                                    ? "2px solid #D32F2F"
                                                                    : "2px solid #6999FF",
                                                        }}
                                                    >
                                                        <AvatarImage userId={user.id} size="sm" />
                                                    </div>

                                                    {/* Text */}
                                                    <div className="min-w-0">
                                                        <p className="text-[13px] font-medium text-[#101828] leading-tight truncate mb-0.5">
                                                            {name} {isCurrentUser && "(You)"}
                                                        </p>
                                                        <p className="text-[12px] text-[#6A7282] truncate m-0">
                                                            {user.employeeRole}
                                                        </p>
                                                    </div>
                                                </div>
                                            </OverlayTrigger>
                                        );
                                    })
                                )}
                            </div>


                            {/* <div className="flex justify-end gap-3 pt-3 border-t">
                            <button
                                onClick={handleCloseUsersModal}
                                className="rounded-[10px] bg-[#F9F6FF] border px-4 py-2 text-sm"
                            >
                                Cancel
                            </button>
                        </div> */}
                        </>

                    </div>
                </div>
            }
        </>
    )
}

export default ChatParticipantModal